import { AiStrategy } from "@towersystems/roam-common/lib/generated-types";
import React from "react";

export const ScreenContext = React.createContext<{
  setStrategy: (strategy: AiStrategy | undefined) => void;
  data: { strategy: AiStrategy | undefined } | undefined;
}>({
  data: undefined,
  setStrategy: () => {},
});

export const GeminiModels = [
  {
    value: "gemini-1.5-pro",
    label: "Gemini 1.5 Pro",
    description:
      "Google's advanced Gemini 1.5 Pro model for high-performance tasks",
  },
  {
    value: "gemini-2-flash",
    label: "Gemini 2 Flash",
    description: "A fast and efficient variant of Gemini 2",
  },
  {
    value: "gemini-2.5-flash",
    label: "Gemini 2.5 Flash",
    description: "The latest Gemini 2.5 Flash model with enhanced capabilities",
  },
];

export const OpenAiDalleModels = [
  {
    value: "dall-e-2",
    label: "DALL·E 2",
    description: "OpenAI's DALL·E 2 model for high-quality image generation",
  },
  {
    value: "dall-e-3",
    label: "DALL·E 3",
    description:
      "The latest DALL·E 3 model with improved image generation capabilities",
  },
];

export const OpenAiModels = [
  {
    value: "gpt-3.5-turbo",
    label: "GPT-3.5 Turbo",
    description: "OpenAI's efficient and cost-effective model for general use",
  },
  {
    value: "gpt-4",
    label: "GPT-4",
    description: "OpenAI's latest model with improved capabilities",
  },
  {
    value: "gpt-4-turbo",
    label: "GPT-4 Turbo",
    description: "A faster and cheaper variant of GPT-4",
  },
];

export const AnthropiciModels = [
  {
    value: "claude-haiku-4-5",
    label: "Claude Haiku 4.5",
    description: "Anthropic's Claude Haiku 4.5 model for versatile tasks",
  },
  {
    value: "claude-2",
    label: "Claude 2",
    description: "Anthropic's advanced Claude 2 model for complex tasks",
  },
  {
    value: "claude-instant-100k",
    label: "Claude Instant 100k",
    description: "A fast and efficient variant of Claude with extended context",
  },
];
